// Contact links ***************************************************

export const CONTACT_TELEGRAM = "https://t.me/SkeyTix_Team";
export const CONTACT_EMAIL = "tix@skey.network";
export const CONTACT_PHONE = "660537007";

// Other links *****************************************************

export const SKEY_NETWORK_PAGE = "https://skey.network";
